import { useState } from 'react';
import { toast } from 'react-toastify';
import { Heart, X } from 'lucide-react';
import UserService from '../../services/user.service';

/** Compact testimonial CTA for the sidebar (below Invite & Earn). */
export const Testimonial = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const userService = new UserService();

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (!message.trim()) return;
        setLoading(true);
        try {
            const response = await userService.addTestimonial({ testimonial: message.trim() });
            setMessage('');
            setIsOpen(false);
            toast.success(response.message || 'Thanks for your testimonial!');
        } catch (err: any) {
            toast.error(err?.message || 'Could not submit testimonial');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="relative">
            <div className="rounded-[16px] border border-white/10 bg-black/20 p-4">
                <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-pink-400/20 text-pink-200">
                    <Heart size={18} strokeWidth={2.2} fill="currentColor" />
                </div>
                <p className="text-[15px] font-semibold leading-tight text-white">Share a testimonial</p>
                <p className="mt-1 text-[12px] leading-relaxed text-white/65">
                    Tell other parents about your RYD Learning experience.
                </p>
                <button
                    type="button"
                    onClick={() => setIsOpen((v) => !v)}
                    className="mt-3.5 w-full rounded-[10px] border border-white/25 bg-white/10 px-3 py-2.5 text-[13px] font-semibold text-white transition hover:bg-white/15"
                >
                    {isOpen ? 'Close' : 'Write testimonial'}
                </button>
            </div>

            {isOpen && (
                <div className="absolute bottom-full left-0 right-0 z-50 mb-2 overflow-hidden rounded-[16px] border border-white/15 bg-white shadow-[0_16px_40px_rgba(0,0,0,0.25)]">
                    <div className="relative bg-ryd-primary px-4 py-3 pr-10">
                        <p className="text-[13px] font-medium leading-snug text-white">
                            Hi 👋 We’re thrilled to hear from you!
                        </p>
                        <button
                            type="button"
                            aria-label="Close"
                            onClick={() => setIsOpen(false)}
                            className="absolute right-2.5 top-2.5 rounded-lg p-1 text-white/80 hover:bg-white/10 hover:text-white"
                        >
                            <X size={16} />
                        </button>
                    </div>
                    <form onSubmit={handleSubmit} className="space-y-3 p-3.5">
                        <textarea
                            placeholder="Write your testimonial..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="w-full resize-none rounded-xl border border-[#efe6f1] bg-[#FBF8FC] px-3 py-2.5 text-[13px] text-[#334155] outline-none placeholder:text-[#94a3b8] focus:border-ryd-primary"
                            rows={4}
                            required
                        />
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full rounded-[10px] bg-ryd-primary px-3 py-2.5 text-[13px] font-semibold text-white transition hover:bg-ryd-primary/90 disabled:opacity-60"
                        >
                            {loading ? 'Submitting…' : 'Submit testimonial'}
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
};
